module.exports = __webpack_public_path__ + "static/img/Send18.06f733b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send18.png
// module id = VTwM
// module chunks = 0